module.exports = __webpack_public_path__ + "static/media/main-background.f778d027.jpg";